import ValidCode from './ValidCode';
import './style/valid-code.less';

export default ValidCode;
